
import request from '../utils/request';

//查看组织架构
export function aboutBuild(data) {
  return request({
    url: '/dept/treeSelect',
    method: 'get',
    params:data
  })
}